<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <div>
    <div v-for="field in fields" :key="field.attribute">
      <!-- ZipCode -->
      <v-text-field
        v-if="field.type === 'text' && field.attribute === 'zipCode'"
        :label="field.label"
        v-model="zipCodeUpper"
        :rules="field.rules"
        :counter="field.maxlength || 255"
        persistent-counter
        :hint="field.hint"
        :maxlength="field.maxlength || 255"
        :readonly="field.readonly"
        :variant="field.readonly ? 'filled' : 'underlined'"
        :disabled="field.disabled"
      >
        <template v-slot:prepend>
          <v-tooltip location="bottom">
            <template v-slot:activator="{ props }">
              <v-icon v-bind="props" v-show="field.altText">mdi-information</v-icon>
            </template>
            {{ field.altText }}
          </v-tooltip>
        </template>
      </v-text-field>

      <v-text-field
        v-if="field.type === 'text' && field.attribute === 'altZipCode'"
        :label="field.label"
        v-model="altZipCodeUpper"
        :rules="field.rules"
        :counter="field.maxlength || 255"
        persistent-counter
        :hint="field.hint"
        :maxlength="field.maxlength || 255"
        :readonly="field.readonly"
        :variant="field.readonly ? 'filled' : 'underlined'"
        :disabled="field.disabled"
      >
        <template v-slot:prepend>
          <v-tooltip location="bottom">
            <template v-slot:activator="{ props }">
              <v-icon v-bind="props" v-show="field.altText">mdi-information</v-icon>
            </template>
            {{ field.altText }}
          </v-tooltip>
        </template>
      </v-text-field>

      <!-- Text -->
      <v-text-field
        v-if="field.type === 'text' && field.attribute !== 'zipCode' && field.attribute !== 'altZipCode'"
        :label="field.label"
        v-model="localEntity[field.attribute]"
        :rules="field.rules"
        :counter="field.maxlength || 255"
        persistent-counter
        :hint="field.hint"
        :maxlength="field.maxlength || 255"
        :readonly="field.readonly"
        :variant="field.readonly ? 'filled' : 'underlined'"
        :disabled="field.disabled"
      >
        <template v-slot:prepend>
          <v-tooltip location="bottom">
            <template v-slot:activator="{ props }">
              <v-icon v-bind="props" v-show="field.altText">mdi-information</v-icon>
            </template>
            {{ field.altText }}
          </v-tooltip>
        </template>
      </v-text-field>

      <!-- Number -->
      <v-text-field
        v-if="field.type === 'number'"
        type="number"
        v-model="localEntity[field.attribute]"
        :counter="field.maxlength || 255"
        persistent-counter
        :rules="field.rules"
        :label="field.label"
        :hint="field.hint"
        :maxlength="field.maxlength || 255"
        :readonly="field.readonly"
        :variant="field.readonly ? 'filled' : 'underlined'"
        :disabled="field.disabled"
        @keypress="isNumber($event)"
      ></v-text-field>

      <!-- Date -->
      <v-menu
        v-if="field.type === 'date'"
        v-model="field.showDatePicker"
        :close-on-content-click="false"
        transition="scale-transition"
        max-width="290px"
        min-width="auto"
      >
        <template v-slot:activator="{ props }">
          <v-text-field
            v-if="field.type === 'date'"
            :model-value="$filters.moment(localEntity[field.attribute], dateFormat)"
            :label="field.label"
            persistent-hint
            prepend-icon="mdi-calendar"
            readonly
            v-bind="props"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="localEntity[field.attribute]"
          @update:modelValue="field.showDatePicker = false"
        ></v-date-picker>
      </v-menu>

      <!-- Select -->
      <v-select
        v-if="field.type === 'select'"
        :items="field.items"
        v-model="localEntity[field.attribute]"
        item-title="name"
        item-value="id"
        :readonly="field.readonly"
        :label="field.label"
        :rules="field.rules"
        :disabled="field.disabled"
        @update:modelValue="field.changeEvent ? field.changeEvent() : undefined"
      ></v-select>

      <!-- Multi Select -->
      <v-select
        v-if="field.type === 'multi-select'"
        v-model="localEntity[field.attribute]"
        :items="field.items"
        :label="field.label"
        item-title="name"
        item-value="id"
        multiple
        chips
        closable-chips
        persistent-hint
      ></v-select>

      <!-- Checkbox -->
      <v-checkbox
        v-if="field.type === 'checkbox'"
        :label="field.label"
        v-model="localEntity[field.attribute]"
        @click="onClick(field.click)()"
        :readonly="field.readonly"
        :disabled="field.disabled"
      >
      </v-checkbox>

      <!-- Radio Group -->
      <v-radio-group
        v-if="field.type === 'radio'"
        :label="field.label"
        :rules="field.rules"
        v-model="localEntity[field.attribute]"
        color="primary"
      >
        <v-radio v-for="item in field.items" :key="item.id" :label="item.name" :value="item.id" />
      </v-radio-group>

      <!-- upload file -->
      <v-file-input
        v-if="field.type === 'uploadFile'"
        :ref="field.ref"
        :accept="field.accept"
        :label="field.label"
        :prepend-icon="field.icon"
        v-model="localEntity[field.attribute]"
        :disabled="field.disabled"
        variant="filled"
        density="compact"
        style="cursor: pointer"
        color="primary"
        clear-icon="mdi-close"
      />
      <!-- Header -->
      <h3 class="text-h5 mt-4 pt-4 mb-4 pb-4" v-if="field.type === 'header'">
        {{ field.label }}
      </h3>
    </div>

    <slot></slot>

    <div>
      <!-- Checkbox -->
      <v-checkbox
        v-if="isActiveField"
        :label="isActiveField.label"
        v-model="localEntity[isActiveField.attribute]"
        :disabled="isActiveField.disabled"
      ></v-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  name: "EntityForm",
  props: {
    entity: Object,
    inputFields: Array,
  },
  emits: ["update:entity"],
  data() {
    return {
      localEntity: this.entity ? { ...this.entity } : {},
      isSyncing: false,
    };
  },
  watch: {
    entity: {
      deep: true,
      handler(newVal) {
        if (this.isSyncing) return;
        this.isSyncing = true;
        this.localEntity = newVal ? { ...newVal } : {};
        this.$nextTick(() => {
          this.isSyncing = false;
        });
      },
    },
    localEntity: {
      deep: true,
      handler(newVal) {
        if (this.isSyncing) return;
        this.isSyncing = true;
        this.$emit("update:entity", newVal);
        this.$nextTick(() => {
          this.isSyncing = false;
        });
      },
    },
  },
  methods: {
    onClick(handler) {
      const empty = () => {};
      return handler || empty;
    },
    isNumber(evt) {
      const keysAllowed = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

      if (!keysAllowed.includes(evt.key) || evt.target.value.length >= evt.target.maxLength) {
        evt.preventDefault();
      }
    },
  },
  computed: {
    zipCodeUpper: {
      get() {
        return this.localEntity.zipCode || "";
      },
      set(value) {
        this.localEntity.zipCode = value.toUpperCase();
      },
    },
    altZipCodeUpper: {
      get() {
        return this.localEntity.altZipCode || "";
      },
      set(value) {
        this.localEntity.altZipCode = value.toUpperCase();
      },
    },
    fields: function() {
      return this.inputFields.filter(f => f.attribute !== "isActive");
    },
    dateFormat() {
      return this.$store.getters["userProfile/dateFormat"];
    },
    isActiveField: function() {
      const field = this.inputFields.find(f => f.attribute === "isActive");
      return field;
    },
  },
};
</script>

<style scoped>
:deep(.v-file-input .v-file-input__text--placeholder),
:deep(.v-file-input .v-file-input__text) {
  cursor: pointer !important;
}
:deep(.v-file-input.v-input--focused .v-input__prepend .v-icon),
:deep(.v-file-input.v-input--focused .v-field__clearable .v-icon) {
  color: rgb(var(--v-theme-primary)) !important;
}
</style>
